import React from 'react';
import Card from '../components/Card';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <h1>About Us</h1>
      <section className='card-section'>
      <Card 
        heading="Our Vision"
        body= {
          <p className="special-text">
            To revolutionize the retail industry with modern technology, offering seamless integration for businesses.
          </p>
        }
      />
      </section>
      <section className='card-section'>
      <Card 
        heading="Our Team"
        body= {
          <p className="special-text">
            A passionate team of professionals focused on innovation, customer satisfaction, and scalability.
          </p>
        }
      />
      </section>
    </div>
  );
};

export default About;
